<template>
  <div class="popup-select" :class="{readonly: readonly}">
    <erp-input size="2" :class="inputClass" :placeholder="placeholder" :disable="disabled" v-if="!readonly" @focus="focus" @blur="blur" @keydown="keyup" v-model="search" />
    <u-icon v-if="active" @click.native.stop.prevent="reset" class="btn-reset absolute-center-right m-r-lg text-primary cursor-pointer" name="times-circle" type="fa" />
    <u-icon class="absolute-center-right m-r-sm helper-chevron" name="chevron-down" type="fa" />
    <div class="helper-bg"></div>
    <popup ref="popup" :async="async" :default-value="value" :emitOnlyValue="emitOnlyValue" :search-data="searchData" @close="closePopup" autofocus v-show="openPopup && !readonly" :active="active" @selected="select" :search-only-select="searchOnlySelect" />
  </div>
</template>

<script>
import {ErpInput} from "uloc-vue-plugin-erp"
import Popup from "./ListSelectPopup"
import {stopAndPrevent} from "uloc-vue/src/utils/event"

export default {
  name: "ListSelect",
  props: {
    value: {
      required: true
    },
    searchData: {
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    emitOnlyValue: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      required: false
    },
    inputClass: {
      type: String
    },
    searchOnlySelect: {
      type: Boolean,
      default: false
    },
    parseCallback: {
      required: false
    }
  },
  data () {
    return {
      search: this.parseCallback ? this.parseCallback(this.value) : (this.value && this.value.label ? this.value.label : this.value),
      active: this.value,
      openPopup: false
    }
  },
  mounted() {
  },
  methods: {
    closePopup () {
      this.openPopup = false
    },
    focus () {
      console.log('Focus...')
      this.openPopup = true
      this.$nextTick(() => {
        this.$refs.popup.focus()
      })
    },
    blur () {
      console.log('Blur...')
      // this.openPopup = false
    },
    select (c) {
      console.log('Selected', c)
      const value = this.emitOnlyValue && typeof c.value !== 'undefined' ? c.value : c
      this.$emit('input', value)
      this.active = c
      this.search = this.parseCallback ? this.parseCallback(c) : c.label
      this.$refs.popup.close()
    },
    keyup (e) {
      stopAndPrevent(e)
    },
    limit (s, l) {
      if (String(s).length <= l) {
        return s
      }
      return String(s).substring(0, l) + '...'
    },
    getNewData () {
      return this.$refs.popup.getNewData()
    },
    reset () {
      this.active = null
      this.search = null
      this.$emit('input', null)
    },
    autoSelectValue (v, done) {
      console.log('Auto select', v)
      if (v.id) {
        this.select(v)
        return
      }
      this.$refs.popup.autoSelectValue(v, done)
    }
  },
  components: {
    Popup,
    ErpInput
  }
}
</script>
